import PropTypes from 'prop-types'
import styled from 'styled-components'

const TextLink = styled.a.attrs(({ dataTestId, target = '_blank', href }) => {
  const attributes = {
    'data-testid': dataTestId,
    href,
    role: 'link',
    tabIndex: '0',
    target,
  }
  return attributes
})`
  display: flex;
  align-items: center;
  color: ${({ disabled }) => (disabled ? 'gray' : '#fff')};
  font-size: 1rem;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: 0.2s;

  &:hover {
    text-decoration: ${({ disabled }) => disabled && 'none'};
    color: ${({ disabled }) => (disabled ? 'gray' : '#ff8a7a')};
  }

  &:focus {
    color: ${({ disabled }) => (disabled ? 'gray' : '#ff8a7a')};
  }

  svg {
    margin: 0 0.5rem 0.1875rem 0;
  }
`

TextLink.propTypes = {
  dataTestId: PropTypes.string.isRequired,
  href: PropTypes.string,
}

TextLink.displayName = 'TextLink'

export default TextLink



// WEBPACK FOOTER //
// ./src/components/TextLink/component.styles.js